export default __webpack_public_path__ + "static/media/profile.0453fc2a.png";